import React, { useState } from 'react';
import { ArrowLeft, Copy, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const TwoEmoji = () => {
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  const twoEmoji = '2️⃣';

  const handleCopy = () => {
    navigator.clipboard.writeText(twoEmoji);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <Helmet>
        <title>Two Emoji 2️⃣ Copy and Paste [2025] | #1 Number Emoji</title>
        <meta name="description" content="【INSTANT COPY】 Get the two number keycap emoji 2️⃣ One-click copy & paste ⚡ Works everywhere! Updated for 2025 ✨ Free number emoji for Instagram, WhatsApp & more!" />
        <link rel="canonical" href="https://emojicollection.net/emoji/two" />
        <meta property="og:title" content="Two Emoji 2️⃣ Copy and Paste [2025] | #1 Number Emoji" />
        <meta property="og:description" content="Get the two number keycap emoji 2️⃣ One-click copy & paste ⚡ Works everywhere! Updated for 2025" />
        <meta property="og:url" content="https://emojicollection.net/emoji/two" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6 transition-colors"
          >
            <ArrowLeft className="mr-2" size={20} />
            Back to Home
          </button>

          <article className="bg-white rounded-2xl shadow-lg p-8">
            <header className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-500 mb-4">
                <span className="text-2xl">2️⃣</span>
              </div>
              <h1 className="text-3xl font-bold text-gray-900 mb-4">
                Two Emoji 2️⃣ Copy and Paste [2025]
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                Get instant access to the two number keycap emoji! Perfect for numbers, scoring, and digital communication. Updated for 2025. One-click copy and paste feature!
              </p>
            </header>

            <section className="max-w-2xl mx-auto mb-12">
              <div className="bg-gray-50 rounded-lg p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  2️⃣ Copy Two Emoji Instantly
                </h2>
                <div className="mb-4 text-center">
                  <span className="text-6xl">{twoEmoji}</span>
                </div>
                <button
                  onClick={handleCopy}
                  className={`w-full inline-flex items-center justify-center px-6 py-3 rounded-lg text-lg font-medium transition-all transform hover:scale-105 ${
                    copied
                      ? 'bg-green-500 text-white'
                      : 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white hover:from-blue-600 hover:to-indigo-600'
                  }`}
                >
                  {copied ? (
                    <>
                      <Check className="mr-2" size={20} />
                      Copied Two Emoji!
                    </>
                  ) : (
                    <>
                      <Copy className="mr-2" size={20} />
                      Copy Two Emoji
                    </>
                  )}
                </button>
              </div>
            </section>

            <section className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-semibold mb-4">✨ Features & Benefits</h2>
              <div className="text-gray-600 space-y-4">
                <p>2️⃣ Two number keycap emoji</p>
                <p>📋 Instant one-click copy functionality</p>
                <p>💫 Works on all platforms and devices</p>
                <p>🆕 Updated for 2025</p>
              </div>
            </section>

            <section className="border-t border-gray-200 mt-8 pt-8">
              <h2 className="text-2xl font-semibold mb-4">❓ Frequently Asked Questions</h2>
              <div className="space-y-4">
                <details className="group bg-gray-50 rounded-lg">
                  <summary className="cursor-pointer p-4 font-medium">Where can I use this emoji?</summary>
                  <div className="p-4 pt-0 text-gray-600">
                    The two emoji works everywhere - social media, messaging apps, emails, documents, and more. It's compatible with all major platforms.
                  </div>
                </details>
                <details className="group bg-gray-50 rounded-lg">
                  <summary className="cursor-pointer p-4 font-medium">Is this emoji free to use?</summary>
                  <div className="p-4 pt-0 text-gray-600">
                    Yes! The two emoji is completely free to use for both personal and commercial purposes. No attribution required.
                  </div>
                </details>
              </div>
            </section>
          </article>
        </div>
      </div>
    </>
  );
};

export default TwoEmoji;